import type {
  RfqCategory,
  RfqPriceMode,
  RfqSectionType,
  RfqUnit,
} from "./types";

export const CATEGORY_DEFAULT_MODE: Record<RfqCategory, RfqPriceMode> = {
  material: "weight",
  fabrication: "weight",
  surface: "unit",
  bolt: "unit",
  transport: "unit",
  other: "unit",
};

export const RFQ_CATEGORIES: RfqCategory[] = [
  "material",
  "fabrication",
  "surface",
  "bolt",
  "transport",
  "other",
];

export const RFQ_PRICE_MODES: RfqPriceMode[] = ["weight", "unit"];

export const UNITS: RfqUnit[] = [
  "KG",
  "TON",
  "支",
  "張",
  "M",
  "M²",
  "SET",
  "箱",
  "車次",
  "式",
];

export const SECTION_TYPES: RfqSectionType[] = [
  "H型鋼",
  "BH組合梁",
  "鋼板",
  "鋼管",
  "角鋼",
  "槽鋼",
  "圓鋼",
  "其他",
];

export const MATERIALS = ["SN490B", "SM490A", "SM400A", "SS400", "A572 Gr.50"];

export const WELD_GRADES = ["全滲透", "部分滲透", "填角"];
export const MEMBER_TYPES = ["BH梁", "箱型柱", "圓管柱", "斜撐", "雜項"];
export const TREATMENTS = ["熱浸鍍鋅", "塗裝", "防火被覆"];
export const BOLT_GRADES = ["F10T", "S10T", "A325", "A490"];
export const BOLT_SIZES = ["M16", "M20", "M22", "M24", "M27"];
export const TRUCK_TYPES = ["半聯結", "全聯結", "低床", "其他"];

export const AWARD_REASON_KEYS = [
  "dueDate",
  "quality",
  "capacity",
  "noMtc",
  "altMaterial",
  "payment",
  "other",
];

export const NOMINAL_UNIT_WEIGHT: Record<string, number> = {
  H400x200x8x13: 66.0,
  H500x200x10x16: 89.6,
  H600x200x11x17: 106.0,
  "H300x150x6.5x9": 36.7,
  "H200x100x5.5x8": 21.3,
  H350x175x7x11: 49.6,
  H250x125x6x9: 29.6,
  L100x100x10: 14.9,
  L75x75x6: 6.85,
  "C150x75x6.5x10": 18.6,
};

export const NOMINAL_SPECS = Object.keys(NOMINAL_UNIT_WEIGHT);
